import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { AppCategoriesAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeFilterCategories() {
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().filterCategories ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().filterCategoriesExclusion ?? false)

	const isExclusion = exclInfo.value

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => setExcl(e.target.checked, 'filterCategoriesExclusion')} size="small"/>
				<Typography variant="body2" sx={{ fontWeight: 500 }}>
					{isExclusion ? 'Exclude categories' : 'Include categories'}
				</Typography>
			</Box>
			<AppCategoriesAutocomplete
				label={isExclusion ? 'Exclude Categories' : 'Include Categories'}
				placeholder={isExclusion ? 'No categories excluded' : 'No categories included'}
				value={dataInfo.value ?? []}
				onChange={e => setDataInfo(e.target.value, 'filterCategories')}
			/>
		</Box>
	)
}